import React from "react";
import { Button } from "react-bootstrap";
import { useGetSocialUserPostsQuery } from "../../../../redux/apiSlice";
import { SocialPost } from "./SocialPost";

export const SocialPosts = ({profileId, selectPost}) => {
    const { isFetching, data } = useGetSocialUserPostsQuery(profileId);
    
    return (
        <div className="col d-flex flex-column h-100 w-100 pt-8">
            <div className="flex-grow-1">
                {
                    (!isFetching && data)
                    && data.data.map((post) => {
                        return <SocialPost post={post} key={post?.postId} selectPost={selectPost}/>
                    })
                }
            </div>
            <div className="d-flex justify-content-between">
                <Button variant="secondary font-weight-bolder">Prev</Button>
                <Button variant="secondary font-weight-bolder">Next</Button>
            </div>
        </div>
    );
};
